<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="d-flex ma-3">
        <div class="topic_breadcrumb_header border_right">เพิ่มสินค้าเข้าคลัง</div>
        <div class="topic_breadcrumb_content ma-2">ระบบ POS</div>
        <div class="topic_breadcrumb_content ma-2"> > </div>
        <div class="topic_breadcrumb_content ma-2">คลังสินค้า</div>
        <div class="topic_breadcrumb_content ma-2"> > </div>
        <div class="topic_breadcrumb_content ma-2">การนำสินค้าเข้าคลัง</div>
        <div class="topic_breadcrumb_content ma-2"> > </div>
        <div class="topic_breadcrumb_content ma-2">เพิ่มสินค้าเข้าคลัง</div>
      </div>
      <div class="mt-5">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
          <template>
            <v-timeline align-top dense>
              <v-timeline-item fill-dot color="#D6BFAF">
                <template v-slot:icon>
                  <div class="logo_timeline mx-auto my-auto">
                    <img src="@/assets/arin_assets/tag.png">
                  </div>
                </template>
                <div class="d-flex" style="margin-top: 2px">
                  <div class="header-content py-1 pl-5 pr-3 text-center">
                    <div class="content-font">ข้อมูลใบสั่งซื้อ</div>
                  </div>
                </div>
                <div class="d-flex justify-end mt-n15">
                  <v-switch dense color="#86bc3a" v-model="input_set.document_status" label="อ้างอิงเลขที่เอกสารในระบบ"></v-switch>
                </div>
                <div class="mt-5">
                  <div class="grid_half">
                    <div class="grid_input_half">
                      <div class="pa-2">
                        <div class="text_title mt-2">เลขที่ใบอ้างอิง/ No. <span class="red--text">*</span></div>
                        <div class="mt-2">
                          <v-autocomplete color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-file-document" :items="po_list" item-text="name" item-value="id" hide-details="auto" v-model="input_set.receipt_po" placeholder="กรุณาเลือกเลขที่ใบอ้างอิง/ No." required outlined></v-autocomplete>
                        </div>
                      </div>
                      <div class="pa-2">
                        <div class="text_title mt-2">เลขที่ใบเสร็จ/ใบ CN <span class="red--text">*</span></div>
                        <div class="mt-2">
                          <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-file-document" hide-details="auto" required v-model="input_set.promotion_name" placeholder="กรุณากรอกเลขที่ใบเสร็จ/ใบ CN" outlined></v-text-field>
                        </div>
                      </div>
                      <div class="pa-2">
                        <div class="text_title mt-2">ชื่อ บริษัท/Supplier Name</div>
                        <div class="pt-6 pl-2 sub_content_text">{{input_set.supplier_name}}</div>
                      </div>
                      <div class="pa-2">
                        <div class="text_title mt-2">วันที่ใบเสร็จ <span class="red--text">*</span></div>
                        <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <div class="mt-2">
                              <v-text-field clearable color="#D6BFAF" class="input-radius" v-model="date" placeholder="กรุณาเลือกวันที่ใบเสร็จ" :rules="[v => !!v || 'กรุณาเลือกวันที่ใบเสร็จ']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                            </div>
                          </template>
                          <v-date-picker locale="TH" color="#D6BFAF" v-model="date" :min="start_date" no-title scrollable></v-date-picker>
                        </v-menu>
                      </div>
                    </div>
                    <div>
                      <div class="pa-2">
                        <div class="text_title mt-2">ภาษีการซื้อ <span class="red--text">*</span></div>
                        <v-radio-group v-model="input_set.vat_purchase">
                          <div class="d-flex justify-space-around">
                            <div class="d-flex mr-1">
                              <div>
                                <v-radio color="#D6BFAF" :value="0"></v-radio>
                              </div>
                              <div>ภาษีรวมใน</div>
                            </div>
                            <div class="d-flex ml-6">
                              <div>
                                <v-radio color="#D6BFAF" :value="1"></v-radio>
                              </div>
                              <div>ภาษีแยกนอก</div>
                            </div>
                            <div class="d-flex ml-6">
                              <div>
                                <v-radio color="#D6BFAF" :value="2"></v-radio>
                              </div>
                              <div>ไม่กระทบภาษี</div>
                            </div>
                            <div class="d-flex ml-6">
                              <div>
                                <v-radio color="#D6BFAF" :value="3"></v-radio>
                              </div>
                              <div>ภาษีเป็น 0</div>
                            </div>
                          </div>
                        </v-radio-group>
                      </div>
                      <div class="pa-2">
                        <div class="text_title mt-2">ประเภท <span class="red--text">*</span></div>
                        <v-radio-group v-model="input_set.type">
                          <div class="grid_input_half">
                            <div class="d-flex justify-space-around">
                              <div class="d-flex mr-1">
                                <div>
                                  <v-radio color="#D6BFAF" :value="0"></v-radio>
                                </div>
                                <div>เงินสด</div>
                              </div>
                              <div class="d-flex ml-6">
                                <div>
                                  <v-radio color="#D6BFAF" :value="1"></v-radio>
                                </div>
                                <div>เครดิต</div>
                              </div>
                            </div>
                          </div>
                        </v-radio-group>
                      </div>
                    </div>
                  </div>
                </div>
              </v-timeline-item>
              <v-timeline-item fill-dot color="#D6BFAF">
                <template v-slot:icon>
                  <div class="logo_timeline mx-auto my-auto">
                    <img src="@/assets/arin_assets/cycle.png">
                  </div>
                </template>
                <div class="d-flex" style="margin-top: 2px">
                  <div class="header-content py-1 pl-5 pr-3 text-center">
                    <div class="content-font">ข้อมูลใบสั่งซื้อ</div>
                  </div>
                </div>
                <div class="mt-5">
                  <div class="grid_product">
                    <div class="pa-2">
                      <div class="text_title mt-2">สินค้า <span class="red--text">*</span></div>
                      <div class="d-flex">
                        <div class="mt-2 width_input">
                          <v-autocomplete color="#D6BFAF" class="input-radius" :items="product_list" item-text="name" item-value="id" hide-details="auto" v-model="input_set.product_id" placeholder="สินค้า" required outlined></v-autocomplete>
                        </div>
                        <div class="ml-5 my-auto">
                          <v-btn elevation="3" class="mt-1" outlined height="50" color="#ADADAD" style="border-radius: 10px;background-color: #FFFFFF" title="เพิ่มสินค้า">
                            เพิ่มสินค้า
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pa-2">
                    <div class="d-flex justify-end">
                      <div class="mt-1">
                        <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required v-model="search" placeholder="ค้นหา..." outlined></v-text-field>
                      </div>
                    </div>
                  </div>
                  <div class="pa-2">
                    <v-data-table :headers="headers" key="index" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
                      <template v-slot:item="dataDetail">
                        <tr>
                          <td class="text-center align_top">
                            <div class="mt-4">{{ dataDetail.index + 1 }}</div>
                          </td>
                          <td class="align_top">
                            <div class="mt-4">{{dataDetail.item.product_code}}</div>
                          </td>
                          <td class="align_top">
                            <div class="mt-4">
                              <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto" v-model="dataDetail.item.lot_no" placeholder="กรุณาระบุล็อต" required outlined></v-text-field>
                            </div>
                          </td>
                          <td class="align_top">
                            <div class="my-4">{{dataDetail.item.product_name}}</div>
                            <div class="pa-2">
                              <div class="text_title mt-2">วันที่หมดอายุ <span class="red--text">*</span></div>
                              <div class="d-flex">
                                <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                  <template v-slot:activator="{ on, attrs }">
                                    <div class="mt-2">
                                      <v-text-field clearable color="#D6BFAF" class="input-radius" v-model="dataDetail.item.date_expired" placeholder="กรุณาเลือกวันที่หมดอายุ" :rules="[v => !!v || 'กรุณาเลือกวันที่หมดอายุ']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                                    </div>
                                  </template>
                                  <v-date-picker locale="TH" color="#D6BFAF" v-model="date" :min="start_date" no-title scrollable></v-date-picker>
                                </v-menu>
                              </div>
                            </div>
                          </td>
                          <td class="align_top">
                            <div class="mt-4">
                              <v-autocomplete color="#D6BFAF" class="input-radius" :items="dataDetail.item.unit_list" item-text="unit_name" item-value="id" hide-details="auto" v-model="dataDetail.item.unit_id" required outlined></v-autocomplete>
                            </div>
                          </td>
                          <td class="align_top">
                            <div class="mt-4">
                              <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto" v-model="dataDetail.item.receive_qty" placeholder="กรุณาระบุจำนวนที่ได้รับ" required outlined></v-text-field>
                            </div>
                            <div class="mt-4">
                              <div class="text_title mt-2">ส่วนลด(บาท)</div>
                              <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto" v-model="dataDetail.item.discount_bath" placeholder="ส่วนลด(บาท)" outlined></v-text-field>
                            </div>
                          </td>
                          <td class="align_top">
                            <div class="mt-4">
                              <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto" v-model="dataDetail.item.price_per_unit" placeholder="กรุณาระบุราคาต่อหน่วย" required outlined></v-text-field>
                            </div>
                            <div class="mt-4">
                              <div class="text_title mt-2">ส่วนลด(%)</div>
                              <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto" @keypress="isCurrency($event, dataDetail.item.discount_percent)" v-model="dataDetail.item.discount_percent" placeholder="ส่วนลด(%)" outlined></v-text-field>
                            </div>
                          </td>
                          <td class="align_top">
                            <div class="text-center my-6">{{dataDetail.item.total}}</div>
                          </td>
                          <td class="align_top pt-3">
                            <v-btn elevation="3" class="ma-2" outlined small height="45" color="#F28080" style="border-radius: 10px;background-color: #FFFFFF" title="ลบข้อมูล">
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                      <template v-slot:body.append>
                        <tr>
                          <td class="background_td"></td>
                          <td class="background_td"></td>
                          <td class="background_td"></td>
                          <td class="background_td"></td>
                          <td class="pa-2 background_td">
                            <div class="text-left content_total_text">รวม</div>
                          </td>
                          <td colspan="3" class="background_td">
                            <div class="text-right content_total_text">11,775.00</div>
                          </td>
                          <td class="background_td"></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td class="pa-2">
                            <div class="text-left">ส่วนลดท้ายบิล</div>
                          </td>
                          <td></td>
                          <td></td>
                          <td colspan="2">
                            <div class="pa-2">
                              <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto" v-model="input_set.discount_bill" placeholder="ส่วนลดท้ายบิล" outlined></v-text-field>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td class="pa-2">
                            <div class="text-left my-5">ราคาสินค้าไม่รวมภาษี</div>
                            <div class="text-left my-5">ภาษีมูลค่าเพิ่ม 7%</div>
                          </td>
                          <td colspan="3">
                            <div class="text-right my-5">11,775.00</div>
                            <div class="text-right my-5">824.25</div>
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td class="background_td"></td>
                          <td class="background_td"></td>
                          <td class="background_td"></td>
                          <td class="background_td"></td>
                          <td class="pa-2 background_td">
                            <div class="text-left content_total_text" style="font-size: 14px">จำนวนเงินทั้งสิ้นรวมภาษี</div>
                          </td>
                          <td colspan="3" class="background_td">
                            <div class="text-right content_total_text">12,599.25</div>
                          </td>
                          <td class="background_td"></td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </v-timeline-item>
            </v-timeline>
          </template>
          <div class="text-center">
            <v-btn height="45" class="white--text grad-success-arin-bg mobile_btn" style="font-size: 18px; border-radius: 10px;">บันทึก</v-btn>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {minDate, onlyForCurrency} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_promotion_create",
  data() {
    return {
      loading_page: false,
      menu_date: false,
      start_date: this.min_date(),
      date: '',
      search: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      input_set: {
        receipt_po: '',
        receipt_cn: '',
        supplier_name: 'บริษัท ฟาร์มาแคร์ พลัส จำกัด',
        vat_purchase: 1,
        type: 0,
        document_status: true,
        discount_bill: '0',
      },
      po_list: [
        {id: 1, name: 'PO-220420220001'},
        {id: 2, name: 'PO-220420220002'},
        {id: 3, name: 'PO-220420220003'},
        {id: 4, name: 'PO-220420220004'},
        {id: 5, name: 'PO-220420220005'},
      ],
      product_list: [
        {id: 1, name: 'ก'},
        {id: 2, name: 'ข'},
        {id: 3, name: 'ค'},
        {id: 4, name: 'ฅ'},
        {id: 5, name: 'ง'},
      ],
      headers: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '100px',
          align: 'center',
        },
        {
          text: 'รหัสสินค้า',
          value: '',
          fixed: true,
          width: '140px',
          align: 'left',
        },
        {
          text: 'ล็อต',
          value: '',
          fixed: true,
          width: '150px',
          align: 'left',
        },
        {
          text: 'รายการสินค้า',
          value: '',
          fixed: true,
          width: '350px',
          align: 'left',
        },
        {
          text: 'หน่วยนับ',
          value: '',
          fixed: true,
          width: '180px',
          sortable: false,
          align: 'center',
        },
        {
          text: 'จำนวนที่ได้รับ',
          value: '',
          fixed: true,
          width: '180px',
          sortable: false,
          align: 'left',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: '',
          fixed: true,
          width: '180px',
          sortable: false,
          align: 'left',
        },
        {
          text: 'ราคารวม',
          value: '',
          fixed: true,
          width: '160px',
          sortable: false,
          align: 'center',
        },
        {
          text: 'ลบ',
          value: '',
          fixed: true,
          width: '60px',
          sortable: false,
          align: 'left',
        },
      ],
      data_list: [
        {
          id: 1,
          product_code: 'ANB0015',
          lot_no: '6100912',
          product_name: 'inj.GLUCOSE 20 CC for *INJection* 10.-',
          date_expired: '17/11/2028',
          unit_list: [
            {id: 1, unit_name: 'AMPULE'},
            {id: 2, unit_name: 'AMPULE'},
            {id: 3, unit_name: 'AMPULE'},
            {id: 4, unit_name: 'AMPULE'},
            {id: 5, unit_name: 'AMPULE'},
          ],
          unit_id: 1,
          receive_qty: '75',
          price_per_unit: '75',
          total: '5,625.00',
          discount_bath: '',
          discount_percent: '',
        },
        {
          id: 2,
          product_code: 'BER3029',
          lot_no: '322200102',
          product_name: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
          date_expired: '26/05/2025',
          unit_list: [
            {id: 1, unit_name: 'BX(10)'},
            {id: 2, unit_name: 'BX(10)'},
            {id: 3, unit_name: 'BX(10)'},
            {id: 4, unit_name: 'BX(10)'},
            {id: 5, unit_name: 'BX(10)'},
          ],
          unit_id: 1,
          receive_qty: '10',
          price_per_unit: '615',
          total: '6,150.00',
          discount_bath: '',
          discount_percent: '',
        },
      ],
    }
  },
  methods: {
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    min_date: function() {
      return minDate()
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
  },
}
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}
.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}
.logo_timeline {
  width: 25px;
  height: 25px;
}
.logo_timeline>img {
  max-width: 25px;
}
/* .header-content {
  margin-left: -45px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
} */
.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}
.input-radius {
  border-radius: 10px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.sub_content_text {
  font-weight: 500;
  font-size: 16px;
  color: #838383;
}
.grid_product {
  display: grid;
  grid-template-columns: 60% 40%;
}
.width_input {
  width: 100%;
}
.mobile_btn {
  width: 10%;
}
.align_top {
  vertical-align: top;
}
.content_total_text {
  font-weight: 600;
  font-size: 18px;
  color: #616A6B;
}
.background_td {
  background-color: rgba(241, 233, 227, 0.49);
}
</style>
